import { Box, Button } from '@fozito/common-ui';
import { Form, FormInstance } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IFormCheckValue } from './ModalInfo';
import CheckUI from './CheckUI';
import CheckSignature, { CheckSignatureRef } from './Signature';
type Props = {
  form: FormInstance<any>;
  onFinish: (values: any) => Promise<void>;
  checkRef: React.RefObject<CheckSignatureRef>;
  onClose?: () => void;
};
const CheckWithSignatureForm = ({ checkRef, form, onFinish, onClose = () => undefined }: Props) => {
  return (
    <FormStyled form={form} onFinish={onFinish}>
      <Form.Item name={'detail'} noStyle />
      <Form.Item name={'amount'} noStyle />
      <Form.Item name={'checkInfo'} noStyle />
      <Form.Item name={'date'} noStyle />
      <Form.Item name={'formInfoValue'} noStyle />
      <Box display='flex' flex={1}>
        <div className="check-ui">
          <div className="check-border-1">
            <div className="check-border-2">
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  const formInfoValue: IFormCheckValue = getFieldValue('formInfoValue');
                  const date = getFieldValue('date');
                  const signature = getFieldValue('signature');
                  return <CheckUI
                    checkNum={formInfoValue?.no}
                    amount={formInfoValue?.amount}
                    checkingAccount={formInfoValue?.accountNumber}
                    routerNumber={formInfoValue?.routingNumber}
                    date={date}
                    forCheckNote={formInfoValue?.bankFor}
                    name={formInfoValue?.name}
                    signature={signature}
                  />;
                }}
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="signature-ui">
          <Form.Item noStyle name={'signature'} rules={[{ required: true, message: 'Please sign here' }]}>
            <CheckSignature ref={checkRef} ratio={1.5} style={{ padding: 0, margin: 0, alignSelf: 'stretch', minWidth: '850px' }} />
          </Form.Item>
        </div>

      </Box>
      <FooterActions>
        <Button type_cancel onClick={onClose}>Close</Button>
        <Button type_cancel onClick={() => checkRef.current?.clear()}>Clear</Button>
        <Button type_primary type='submit'>OK</Button>
      </FooterActions>
    </FormStyled>
  );
};

export default CheckWithSignatureForm;

const FormStyled = styled(Form)`
display: flex;
flex: 1 0 0;
align-self: stretch;
flex-direction: column;
.check-ui {
  flex: 1;
  border-right: 1px solid #86909C;
  background: #F6F7FC;
  align-self: stretch;
  display: flex;
  zoom: 1.5;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .check-border-1 {
    border: 4.73px solid #777D7C;
    background: #FFF; 
    padding: 9.46px; 
    width: 700px;
    .check-border-2 {
      border: 1.183px solid #777D7C;
      background: #FFF;
      padding: 9.46px 18.92px;
    }
  }
}

.signature-ui {
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 16px;
}
`;

const FooterActions = styled.div`
display: flex;
padding: 16px 16px 24px 16px;
align-items: flex-end;
gap: 16px;
align-self: stretch;
zoom: 1.5;
background: #FFF;
box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.15);
button {
  flex: 1;
}
`;
